module.exports = __webpack_public_path__ + "img/ourTipp.d00ddb5.jpg";